import React from 'react'
import Layout from '../../../../../component/layout/Layout'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const HydrostaticHeadTesterTarpaulin = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000
    };

    const images = [
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2Finstruments%2FTextileTesting%2Fimg%2F9.png?alt=media&token=6e2bbf82-ef7d-4fd4-858d-97feb8c6e51a',
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2Finstruments%2FTextileTesting%2Fimg%2F9.png?alt=media&token=6e2bbf82-ef7d-4fd4-858d-97feb8c6e51a'
    ];

    return (
        <Layout>
            <div className="bread">
                <ul className="collapsed">
                    <li><a href="/">Home</a></li>
                    <li><a href="/textile">Textile</a></li>
                </ul>
            </div>
            <div className="container">
                <div className="section-title text-center" style={{ marginBottom: '2rem' }}>
                    <h1>Hydrostatic Head Tester for Tarpaulin</h1>
                </div>
            </div>
            <section id="portfolio-details" className="portfolio-details" style={{ backgroundColor: 'white', marginBottom: '12rem' }}>
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-lg-8">
                            <div className="portfolio-details-slider swiper">
                                <Slider {...settings}>
                                    {images.map((src, index) => (
                                        <div className="swiper-slide" key={index}>
                                            <div className="img" style={{ alignItems: 'center' }}>
                                                <img src={src} alt="" className="responsive" />
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                                <div className="swiper-pagination"></div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="portfolio-info" style={{ backgroundColor: 'white' }}>
                                <h3 className='pageheading'>Hydrostatic Head Tester for Tarpaulin</h3>
                                <p className='descriptionHead' style={{ textAlign: 'justify' }}>
                                    This tester applies water pressure at a constant rate on tarpaulin; the pressure at which water first penetrates the tarpaulin is recorded as its hydrostatic pressure characteristic. Conforms to Standards: AATCC 127, JIS L1092, ISO 811.
                                    <br /><br />
                                    <a
                                        href="mailto:inst@rmc.in?subject=Inquiry about Hydrostatic Head Tester for Tarpaulin"
                                        style={{ color: '#0d6efd', fontWeight: '600', textDecoration: 'underline' }}
                                    >
                                        More Info
                                    </a>
                                </p>
                            </div>
                            <div className="portfolio-description"></div>
                        </div>
                    </div>
                </div>
            </section>
            <br /><br /><br /><br />
        </Layout>
    )
}

export default HydrostaticHeadTesterTarpaulin
